import type { Maybe } from '@adornis/base/utilTypes.js';
import { ChemistryLitElement } from '@adornis/chemistry/chemistry-tailwind-lit-element.js';
import { css } from '@adornis/chemistry/directives/css.js';
import { ChromiumDialog } from '@chancenwerk/client/design/components/cr-dialog.js';
import type { Workshop } from '@chancenwerk/shared/workshops/entities/Workshop.js';
import { html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { AkademieDialogWorkshopEdit } from './dialogs/akademie-dialog-workshop-edit.js';

/**
 * @customElement akademie-component-workshop-entry
 */
@customElement('akademie-component-workshop-entry')
export class AkademieComponentWorkshopEntry extends ChemistryLitElement {
  @property({ attribute: false }) workshop: Maybe<Workshop> = null;

  override render() {
    if (!this.workshop) {
      return nothing;
    }

    return html`<cr-card padding="md" space="md" ${css(this.workshop.active ? {} : { opacity: 0.7 })}>
      <chancen-component-card-title>
        <cr-flex horizontal crossaxis-center space="sm">
          ${
            this.workshop.active
              ? html`<cr-icon ${css({ color: this.colors.tone.success })}>play_arrow</cr-icon>`
              : html`<cr-icon ${css({ color: this.colors.tone.neutral })}>pause</cr-icon>`
          }
          Workshop: ${this.workshop.title}
        </cr-flex>
        <cr-flex horizontal space="sm" slot="right">
          <cr-button
            mode="icon"
            icon="edit"
            @click=${async () => {
              await AkademieDialogWorkshopEdit.showPopup({
                props: {
                  workshop: this.workshop,
                },
              });
            }}
          ></cr-button>
          <cr-button
            mode="icon"
            icon="delete"
            tone="error"
            @click=${async () => {
              await ChromiumDialog.guard(
                async () => {
                  await this.workshop?.remove();
                  this.dispatchEvent(new CustomEvent('workshop-deleted', { detail: { workshop: this.workshop } }));
                },
                { hasToConfirm: true, errorMessagePrefix: 'Fehler beim Löschen des Workshops' },
              );
            }}
          ></cr-button>
        </cr-flex>
      </chancen-component-card-title>
      <cr-flex horizontal space-between space="lg" ${css({ alignItems: 'baseline' })}>
        <cr-nospace-toggle-content .label=${'Beschreibung'} ${css({ marginTop: this.spacing.xs })}>
          <cr-flex space="md">
            <cr-text>${unsafeHTML(this.workshop.description)}</cr-text>
            <cr-text bold>Zielgruppe:</cr-text>
            <cr-text> ${this.workshop.audience} </cr-text>
            <cr-flex horizontal space="sm">
              <cr-text>
                ${(this.workshop.roles ?? []).join(', ')}
              </cr-text>
            </cr-flex>
        </cr-nospace-toggle-content>
        <cr-button
          small
          ${css({ maxWidth: '180px' })}
          @click=${() => {
            this.dispatchEvent(new CustomEvent('show-details', { detail: { workshop: this.workshop } }));
          }}
        >
          Details
        </cr-button>
      </cr-flex>
    </cr-card>`;
  }
}
